






















































































































































import Vue, { PropType } from 'vue';
import Button from '@/components/form/Button.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import {
  IChipsData,
  TCollectionIcons,
  TDropDownList,
  typeTraffic,
} from '@/types';
import {
  EDefaultNativeSize,
  EDefaultPushSize,
  EEmptySlotTypes,
  IStatePlacements,
} from '@/types/publisher/inventory';
import truffleKitIcons from '@/utils/truffleKitIcons';
import PlacementAutoContent from './PlacementAutoContent.vue';
import PlacementCustomContent from './PlacementCustomContent.vue';
import publisherIcons from './publisherIcons';
import PlacementTypeBanner from './PlacementTypeBanner.vue';
import PlacementTypeNative from './PlacementTypeNative.vue';
import PlacementTypePush from './PlacementTypePush.vue';

export default Vue.extend({
  name: 'InventoryPlacement',
  components: {
    WidgetWrapper,
    FieldInput,
    Button,
    FieldSelect,
    PlacementTypeBanner,
    PlacementTypeNative,
    PlacementTypePush,
    PlacementCustomContent,
    PlacementAutoContent,
  },
  props: {
    category: {
      type: Array as PropType<Array<IChipsData>>,
      required: true,
      default: () => [],
    },
    existTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    placements(): IStatePlacements {
      return this.$store.getters['publisher/getPlacements'];
    },
    placementsIsExist(): boolean {
      return this.placements?.allIds?.length > 0;
    },
    publisherIcons(): TCollectionIcons {
      return publisherIcons;
    },
    truffleKitIcons(): TCollectionIcons {
      return truffleKitIcons;
    },
    placementTypeBanner(): string {
      return typeTraffic.BANNER;
    },
    placementTypeNative(): string {
      return typeTraffic.NATIVE;
    },
    placementTypePush(): string {
      return typeTraffic.PUSH;
    },
    placementEmptySlotTypeCustom(): string {
      return EEmptySlotTypes.CUSTOM;
    },
  },
  methods: {
    addPlacement(): void {
      this.$store.dispatch('publisher/addPlacement');
    },
    deletePlacement(placementId: string): void {
      this.$store.dispatch('publisher/deletePlacementData', placementId);
    },
    changeType(placementId: string, type: string): void {
      switch (type) {
        case typeTraffic.BANNER:
          this.changeTypeToBanner(placementId);
          break;
        case typeTraffic.NATIVE:
          this.changeTypeToNative(placementId);
          break;
        case typeTraffic.PUSH:
          this.changeTypeToPush(placementId);
          break;
      }
    },
    changeTypeToBanner(placementId: string): void {
      this.changePlacementProperty(placementId, 'type', typeTraffic.BANNER);
      this.changeWidgetParamsProperty(placementId, 'type', typeTraffic.BANNER);
      this.changeWidgetParamsProperty(placementId, 'element', '');
      this.changeWidgetParamsProperty(placementId, 'width', '');
      this.changeWidgetParamsProperty(placementId, 'height', '');
    },
    changeTypeToNative(placementId: string): void {
      this.changePlacementProperty(placementId, 'type', typeTraffic.NATIVE);
      this.changeWidgetParamsProperty(placementId, 'type', typeTraffic.NATIVE);
      this.changeWidgetParamsProperty(placementId, 'element', '');
      this.changeWidgetParamsProperty(
        placementId,
        'width',
        EDefaultNativeSize.width
      );
      this.changeWidgetParamsProperty(
        placementId,
        'height',
        EDefaultNativeSize.height
      );
    },
    changeTypeToPush(placementId: string): void {
      this.changePlacementProperty(placementId, 'type', typeTraffic.PUSH);
      this.changeWidgetParamsProperty(placementId, 'type', typeTraffic.PUSH);
      this.changeWidgetParamsProperty(placementId, 'element', '');
      this.changeWidgetParamsProperty(
        placementId,
        'width',
        EDefaultPushSize.width
      );
      this.changeWidgetParamsProperty(
        placementId,
        'height',
        EDefaultPushSize.height
      );
    },
    changePlacementProperty(
      placementId: string,
      propName: string,
      value: any
    ): void {
      const newDataWithId = {
        id: placementId,
        propName,
        value,
      };

      this.$store.dispatch('publisher/updatePlacementData', newDataWithId);
    },
    changeWidgetParamsProperty(
      placementId: string,
      propName: string,
      value: any
    ): void {
      const newDataWithId = {
        id: placementId,
        propName,
        value,
      };

      this.$store.dispatch(
        'publisher/updatePlacementWidgetParamsData',
        newDataWithId
      );
    },
  },
  data() {
    return {
      placementTypes: [
        {
          label: this.$t('body.table.body.trafficType.banner'),
          value: typeTraffic.BANNER,
        },
        {
          label: this.$t('body.table.body.trafficType.native'),
          value: typeTraffic.NATIVE,
        },
        {
          label: this.$t('body.table.body.trafficType.push'),
          value: typeTraffic.PUSH,
        },
      ] as TDropDownList,
      emptySlotTypes: [
        {
          label: this.$t(
            'pages.inventoryForm.blocks.createPlacement.emptyCustom'
          ),
          value: EEmptySlotTypes.CUSTOM,
        },
        {
          label: this.$t(
            'pages.inventoryForm.blocks.createPlacement.emptyAuto'
          ),
          value: EEmptySlotTypes.AUTO,
        },
      ] as TDropDownList,
    };
  },
});
